<script lang="ts" setup>
import { IconTruckDelivery, IconCircleArrowRight, IconCalendarEvent } from '@/icons';
defineProps<{
  donorCode: string;
  receiverCode: string;
  transferDate: string;
  arrivalDate: string;
}>();
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.header">
      <IconTruckDelivery :size="16" :class="$style.headerIcon" />
      <span :class="$style.headerText">{{ donorCode }}</span>
      <IconCircleArrowRight :size="12" :class="$style.arrowIcon" />
      <span :class="$style.headerText">{{ receiverCode }}</span>
    </div>
    <div :class="$style.row">
      <div :class="$style.pill">
        <IconCalendarEvent :size="16" :class="$style.pillIcon" />
        <span :class="$style.pillLabel">Transfer</span>
        <span :class="$style.pillValue">{{ transferDate }}</span>
      </div>
      <div :class="$style.pill">
        <IconCalendarEvent :size="16" :class="$style.pillIcon" />
        <span :class="$style.pillLabel">Arrival</span>
        <span :class="$style.pillValue">{{ arrivalDate }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  border: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
  border-radius: 10px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
}

.header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 8px;
  border-bottom: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
}

.headerIcon {
  color: var(--ui2-content-tertiary, #978f91);
  flex-shrink: 0;
}

.headerText {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: var(--ui2-content-tertiary, #978f91);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.arrowIcon {
  color: var(--ui2-content-tertiary, #978f91);
  flex-shrink: 0;
}

.row {
  display: flex;
  gap: 4px;
}

.pill {
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 6px;
  background: var(--ui2-background-tone-3, #fafafa);
}

.pillIcon {
  color: var(--ui2-content-tertiary, #978f91);
  flex-shrink: 0;
}

.pillLabel {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: var(--ui2-content-tertiary, #978f91);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pillValue {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: var(--ui2-content-secondary, #655e60);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
